import React from 'react'

import * as Styled from './Skeleton.styled'

type StaticProps = {
  Element: typeof Styled.Element
}

const Skeleton: React.FC & StaticProps = ({ children, ...rest }) => (
  <Styled.Container {...rest}>{children}</Styled.Container>
)

Skeleton.Element = Styled.Element

export default Skeleton
